import React from 'react'
import {ButtonLink} from 'ac_ui'
import {acArrowRight} from 'ac-icon'

const OopsPage: React.FC = (): React.ReactElement => {
  return (
    <div className={'oops-page'}>
      <div className={'oops-to-home'}>
        <ButtonLink
          size={'lg'}
          color={'white'}
          iconPosition={'right'}
          className={'btn-shadow'}
          iconPath={acArrowRight}
          href={'/'}>
          На главную
        </ButtonLink>
      </div>
    </div>
  )
}

export {OopsPage}
